<template>
    <div class="confirm">
        <div class="content">
            <section class="section">
                <b-container v-if="loading" class="confirm--loading">
                    <h4>
                        Stiamo caricando la tua prenotazione...
                    </h4>
                    <b-spinner variant="primary" />
                </b-container>
                <b-container v-if="!loading">
                    <!--
                        il tuo codice di conferma è: BLTTVMAPC
                        il tuo travel id è: 22
                    -->
                    <div class="panel" primary noradius boxed>
                        <div class="section--title">
                            <!--Congratulazioni {{travel_voucher.displayName}},<br>la tua prenotazione è confermata!-->
                            Grazie della tua prenotazione!
                        </div>
                        <p>
                            Ti abbiamo inviato un'email di conferma della prenotazione e, prima del viaggio, riceverai,
                            sempre allo stesso indirizzo email, i voucher, i biglietti e le istruzioni di viaggio.
                        </p>
                        <p>
                            Per qualsiasi informazion scrivici all'indirizzo <b><a :href="'mailto:' + config.site.emailSupport">{{config.site.emailSupport}}</a></b> o contattaci in webchat.
                        </p>
                    </div>

                    <div class="mt-4 pt-2">
                        <h3 class="text-center">
                            <b>{{ travel_voucher.quote.details.title }}</b>
                        </h3>
                        <p class="text-center">
                            Codice conferma: <b>{{ travel_voucher.confirmcode }}</b>
                        </p>
                    </div>

                    <div v-if="travel_voucher.isBooked" class="mt-4">
                        <div class="panel text-center" primary>
                            <div v-if="travel_voucher.bookedAt">
                                Prenotazione confermata in data <strong>{{ travel_voucher.bookedAt }}</strong>
                            </div>
                            <div class="mt-2" v-if="travel_voucher.reservation_info_b64">
                                <strong>
                                    Note relative alla prenotazione
                                </strong>
                                <div v-html="window.atob(travel_voucher.reservation_info_b64)"></div>
                            </div>
                        </div>
                    </div>

                    <div class="detail">
                        <div class="detail--services">
                            <div class="detail--service" v-for="(service,index) in travel_voucher.quote.services" v-bind:key="index">
                                <detail-overnight
                                    v-if="service.type == 'overnight'"
                                    :travel="travel_voucher"
                                />
                                <detail-package
                                    v-if="service.type == 'package'"
                                    :travel="travel_voucher"
                                />
                                <detail-flight
                                    v-if="service.type == 'flight'"
                                    :travel="travel_voucher"
                                />
                            </div>

                            <div class="detail--resume">
                                <div class="panel heading" tertiary boxed>
                                    <div class="title">
                                        Estratto conto della prenotazione
                                    </div>
                                </div>

                                <div class="panel content" boxed>
                                    <b-row>
                                        <b-col>
                                            <div class="detail--resume--totals">
                                                <div>
                                                    <div class="detail--resume--totals--item" v-if="travel_voucher.pricing.overnight_public_price > 0">
                                                        <div class="label">
                                                            Pernotti e servizi
                                                        </div>
                                                        <div class="price">
                                                            {{ travel_voucher.pricing.overnight_public_price }} €
                                                        </div>
                                                    </div>
                                                    <div class="detail--resume--totals--item" v-if="travel_voucher.pricing.package_public_price > 0">
                                                    <div class="label">
                                                        Pacchetto e servizi
                                                    </div>
                                                    <div class="price">
                                                        {{ travel_voucher.pricing.package_public_price }} €
                                                    </div>
                                                    </div>
                                                    <div class="detail--resume--totals--item" v-if="travel_voucher.pricing.transport_public_price > 0">
                                                        <div class="label">
                                                            Voli
                                                        </div>
                                                        <div class="price">
                                                            {{ travel_voucher.pricing.transport_public_price }} €
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="detail--resume--totals--item total">
                                                    <div class="label">
                                                        Totale
                                                    </div>
                                                    <div class="price">
                                                        {{ travel_voucher.public_price }} €
                                                    </div>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>

                        </div>
                    </div>
                </b-container>
            </section>
        </div>
        <b-container fluid>
            <prefooter />
        </b-container>
    </div>
</template>

<script>
    import Vue from 'vue'
    import DetailOvernight from '@/components/detail/detail-overnight'
    import DetailFlight from '@/components/detail/detail-flight'
    import { confirm } from '@/api'
    import PreFooter from '@/components/blocks/prefooter'
    import DetailPackage from '@/components/detail/detail-package'

    export default {
        name: 'confirm',
        components: {
            'detail-overnight': DetailOvernight,
            'detail-flight': DetailFlight,
            'prefooter': PreFooter,
            'detail-package': DetailPackage,
        },
        props: {
            confirm_code: String,
            travel_voucher_id: String,
        },
        data() {
            return {
                loading: true,
                travel_voucher: {},
                config: Vue.prototype.$config,
            }
        },
        computed: {
        },
        created() {
        },
        mounted() {
            confirm({
                confirmcode: this.confirm_code,
                travelVoucherId: this.travel_voucher_id,
            })
            .then(response => {
                this.travel_voucher = response.travelVoucher
                this.loading = false
            })
        },
        methods: {
        },
    }
</script>

<style lang="scss">
    .confirm
    {
        margin-top:140px;
        @include media-breakpoint-up(md)
        {
            margin-top:240px;
        }
        &--loading
        {
            text-align: center;
        }
        .detail
        {
            margin-top:$grid-gutter-width;
        }
    }
</style>